import request from './request'

export function loginApi(data) {
  return request.post('/api/admin/login', data)
}

export function meApi() {
  return request.get('/api/admin/me')
}
